import { fetchBreadsByOrder } from 'reducks/bread/operations'
import { parseHirakanaToKanakana } from 'lib/helper'
import { db, FirebaseDocRefType, FirebaseTimestampType } from 'firebase/index'
import { CategoryType } from 'types/category'
import { BreadType } from 'types/bread'

const sortBreads = async (
  bread: BreadType,
  categories: CategoryType[],
  manufacturerRef: FirebaseDocRefType,
  now: FirebaseTimestampType,
  storeRef: FirebaseDocRefType
): Promise<number> => {
  const breads = await fetchBreadsByOrder(storeRef, manufacturerRef)
  let orderNum = 9999 // orderNum以降の数値が並び替えの対象となる
  const categoryIndex = categories.findIndex((category) => bread.category.id === category.category_ref.id)
  if (categoryIndex !== -1) {
    // 同じカテゴリの商品を取得
    const category = categories[categoryIndex]
    const breadsOfCategory = breads.filter(
      (_bread) => _bread.category && _bread.category.id === category.category_ref.id
    )
    // カテゴリ内で1つめの商品の場合
    if (breadsOfCategory.length === 0) {
      // 先頭のカテゴリの場合、先頭に商品を追加
      if (categoryIndex === 0) {
        orderNum = 1
      } else {
        // 1つずつ前のカテゴリの最終商品のorderを確認する
        for (let i = 0; i < categories.length; i = (i + 1) | 0) {
          const prevCategory = categories[categoryIndex - (i + 1)]
          if (!prevCategory) continue
          const breadsOfPrevCategory = breads.filter((_bread) => _bread.category?.id === prevCategory.category_ref.id)
          const lastBread = breadsOfPrevCategory[breadsOfPrevCategory.length - 1]
          if (!lastBread) continue
          orderNum = lastBread.order + 1
          break
        }
      }
    } else {
      // 新規追加する商品含めて50音順で並べ替え
      const sortedBreads = [...breadsOfCategory, bread].sort((a, b) => {
        return parseHirakanaToKanakana(a.name) < parseHirakanaToKanakana(b.name) ? -1 : 1
      })
      const index = sortedBreads.findIndex((_bread) => _bread.bread_ref?.id === bread.bread_ref?.id)
      // 新規追加する商品が先頭だったら1つ後の商品を取得
      if (index === 0) {
        const nextBread = sortedBreads[index + 1]
        orderNum = nextBread.order
      } else {
        // 新規追加する商品の1つ前の商品を取得
        const prevBread = sortedBreads[index - 1]
        orderNum = prevBread.order + 1
      }
    }
  }
  // 並び替える必要のある商品を更新
  const batch = db.batch()
  for (let i = 0; i < breads.length; i = (i + 1) | 0) {
    const _bread = breads[i]
    if (_bread.order < orderNum) continue
    if (!_bread.bread_ref) continue
    _bread.order += 1
    const _ref = _bread.bread_ref
    delete _bread.bread_ref
    _bread.updated_at = now
    batch.set(_ref, _bread, { merge: true })
  }
  try {
    await batch.commit()
    return orderNum
  } catch (e) {
    console.error(e)
    return orderNum
  }
}

export default sortBreads
